export default __webpack_public_path__ + "069bfb0450f076716bcf58bf2ec7a4bc.png";